module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "category-select"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "category-select-block",
    class: {
      'display-none': _vm.conditionShow.one
    }
  }, [_c('div', {
    staticClass: "category-select-block-name"
  }, [_vm._v("一级分类:")]), _vm._v(" "), _c('ul', {
    class: {
      more: _vm.more.one
    }
  }, _vm._l((_vm.categoryOneData), function(item) {
    return _c('li', {
      class: {
        select_category: item.isSelect
      },
      on: {
        "click": function($event) {
          return _vm.setcate(item.id, item.deep, item.name)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "category-select-more category-select-btn",
    class: {
      'display-none': _vm.more.one
    },
    on: {
      "click": function($event) {
        return _vm.open(1)
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('span', {
    staticClass: "category-select-less category-select-btn",
    class: {
      'display-none': !_vm.more.one
    },
    on: {
      "click": function($event) {
        return _vm.open(1)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('div', {
    staticClass: "category-select-block",
    class: {
      'display-none': _vm.conditionShow.two
    }
  }, [_c('div', {
    staticClass: "category-select-block-name"
  }, [_vm._v("二级分类:")]), _vm._v(" "), _c('ul', {
    class: {
      more: _vm.more.two
    }
  }, _vm._l((_vm.categoryTwoData), function(item) {
    return _c('li', {
      class: {
        select_category: item.isSelect
      },
      on: {
        "click": function($event) {
          return _vm.setcate(item.id, item.deep, item.name)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "category-select-more category-select-btn",
    class: {
      'display-none': _vm.more.two
    },
    on: {
      "click": function($event) {
        return _vm.open(2)
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('span', {
    staticClass: "category-select-less category-select-btn",
    class: {
      'display-none': !_vm.more.two
    },
    on: {
      "click": function($event) {
        return _vm.open(2)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "category-select-block category-select-brand",
    class: {
      'display-none': _vm.conditionShow.three
    }
  }, [_c('div', {
    staticClass: "category-select-block-name"
  }, [_vm._v("品牌:")]), _vm._v(" "), _c('span', {
    staticClass: "category-select-more category-select-btn",
    class: {
      'display-none': _vm.more.three
    },
    on: {
      "click": function($event) {
        return _vm.open(3)
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('span', {
    staticClass: "category-select-less category-select-btn",
    class: {
      'display-none': !_vm.more.three
    },
    on: {
      "click": function($event) {
        return _vm.open(3)
      }
    }
  }, [_vm._v("收起")]), _vm._v(" "), _c('ul', {
    class: {
      more: _vm.more.three
    }
  }, _vm._l((_vm.brandData), function(item) {
    return _c('li', {
      class: {
        select_category_brand: item.isSelect
      },
      on: {
        "click": function($event) {
          return _vm.setBracdSelect(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.logoPath
      },
      on: {
        "error": function($event) {
          return _vm.error(3)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "category-select-block",
    class: {
      'display-none': _vm.conditionShow.four || !_vm.categoryThreeData.length,
    }
  }, [_c('div', {
    staticClass: "category-select-block-name"
  }, [_vm._v("三级分类:")]), _vm._v(" "), _c('ul', {
    class: {
      more: _vm.more.four
    }
  }, _vm._l((_vm.categoryThreeData), function(item) {
    return _c('li', {
      class: {
        select_category: item.isSelect
      },
      on: {
        "click": function($event) {
          return _vm.setcate(item.id, item.deep, item.name)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "category-select-more category-select-btn",
    class: {
      'display-none': _vm.more.four
    },
    on: {
      "click": function($event) {
        return _vm.open(4)
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('span', {
    staticClass: "category-select-less category-select-btn",
    class: {
      'display-none': !_vm.more.four
    },
    on: {
      "click": function($event) {
        return _vm.open(4)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('div', {
    staticClass: "category-select-block border-bottom-none",
    staticStyle: {
      "height": "33px",
      "max-height": "initial"
    }
  }, [_c('div', {
    staticClass: "category-select-block-name"
  }, [_vm._v("条件筛选：")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "height": "75px",
      "max-height": "75px"
    }
  }, [_c('li', [_c('span', {
    staticClass: "category-filter-condition-item section",
    staticStyle: {
      "width": "210px"
    }
  }, [_c('a', [_vm._v("毛利")]), _vm._v(" "), _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commissionSectionMin),
      expression: "commissionSectionMin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.commissionSectionMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commissionSectionMin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("——")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commissionSectionMax),
      expression: "commissionSectionMax"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.commissionSectionMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commissionSectionMax = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "category-filter-condition-item section"
  }, [_c('a', [_vm._v("结算价")]), _vm._v(" "), _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceSectionMin),
      expression: "priceSectionMin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.priceSectionMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.priceSectionMin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("——")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceSectionMax),
      expression: "priceSectionMax"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.priceSectionMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.priceSectionMax = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "category-filter-condition-item section",
    staticStyle: {
      "width": "250px"
    }
  }, [_c('a', [_vm._v("建议零售价")]), _vm._v(" "), _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salePriceMin),
      expression: "salePriceMin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.salePriceMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salePriceMin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("——")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salePriceMax),
      expression: "salePriceMax"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.salePriceMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salePriceMax = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "category-filter-condition-item section"
  }, [_c('a', [_vm._v("毛利率")]), _vm._v(" "), _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitSectionMin),
      expression: "profitSectionMin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profitSectionMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitSectionMin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("——")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitSectionMax),
      expression: "profitSectionMax"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profitSectionMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitSectionMax = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-top": "8px",
      "position": "absolute",
      "right": "0"
    }
  }, [_c('el-button', {
    staticClass: "section-init",
    style: ({
      'border-color': _vm.colorMain,
      background: _vm.colorMain
    }),
    on: {
      "click": _vm.sectionInit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    staticClass: "section-init",
    style: ({
      'border-color': _vm.colorMain,
      background: 'white',
      color: _vm.colorMain,
    }),
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("重置")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "category-filter-condition"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "category-filter-condition-item",
    class: {
      'category-filter-condition-select': _vm.condition.priceSectionSort == 1,
    },
    on: {
      "click": function($event) {
        return _vm.setOrderRule(1)
      }
    }
  }, [_vm._v("最新")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "category-filter-condition-item",
    class: {
      'category-filter-condition-select': _vm.condition.priceSectionSort == 2,
    },
    on: {
      "click": function($event) {
        return _vm.setOrderRule(2)
      }
    }
  }, [_vm._v("毛利")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "category-filter-condition-item2 s1",
    class: {
      s2: _vm.condition.priceSectionSort == 3
    },
    on: {
      "click": _vm.calcPrice
    }
  }, [_vm._v("结算价")]), _vm._v(" "), _c('span', {
    staticClass: "category-filter-condition-check",
    class: {
      ischecked: _vm.condition.hideGoods
    },
    on: {
      "click": _vm.hideGoods
    }
  }, [_vm._v("隐藏已上架产品")]), _vm._v(" "), _c('span', {
    staticClass: "category-filter-condition-check",
    class: {
      ischecked: _vm.condition.isSelf
    },
    staticStyle: {
      "width": "160px"
    },
    on: {
      "click": _vm.isSelf
    }
  }, [_vm._v("仅展示自产自销的商品")]), _vm._v(" "), _c('span', {
    staticClass: "category-filter-condition-page"
  }, [_c('span', [_vm._v(_vm._s(_vm.condition.pageNum))]), _vm._v("/\n        "), _c('span', [_vm._v(_vm._s(_vm.pageCount))]), _vm._v(" "), _c('span', {
    staticClass: "category-filter-condition-prev category-filter-page-default",
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "category-filter-condition-next category-filter-page-default",
    on: {
      "click": _vm.next
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "float-right",
    staticStyle: {
      "height": "34px",
      "line-height": "10px"
    },
    on: {
      "click": _vm.pushAll
    }
  }, [_vm._v("批量加入货架")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item float-right",
    attrs: {
      "effect": "dark",
      "content": "将本页所有商品添加报价至报价篮子，前往报价篮子可以批量导出商品报价",
      "placement": "top",
      "popper-class": "custom-width"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726",
      "height": "34px",
      "line-height": "10px",
      "margin-right": "10px",
      "font-size": "14px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.getPriceAll
    }
  }, [_vm._v("批量获取报价")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "category-goods-wrap"
  }, [_c('ul', {
    staticClass: "category-goods-list"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('li', {
      staticClass: "category-goods-item"
    }, [_c('div', {
      staticClass: "category-goods-image",
      on: {
        "mouseenter": function($event) {
          return _vm.showMask(index)
        },
        "mouseleave": function($event) {
          return _vm.hideMask(index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'Detail',
          query: {
            goodsId: item.goodsId
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.goodsImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "category-cover-image",
      class: {
        a: item.isBill == 1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "category-hover-product",
      class: {
        'display-none': _vm.maskShow[index].isShow
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [(item.isBill == 0) ? _c('span', [_vm._v("\n                          不带票结算价\n                          "), (item.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()]) : _c('span', [_vm._v("\n                          带票结算价\n                          "), (item.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()])]), _vm._v(" "), _c('th', [_vm._v("库存")])])]), _vm._v(" "), _c('tbody', _vm._l((item.products), function(value, index) {
      return (index < 7) ? _c('tr', [_c('td', {
        staticClass: "category-table-SKU"
      }, [_c('div', [_vm._v(_vm._s(value.specName))])]), _vm._v(" "), _c('td', [(item.isBill == 0) ? _c('span', [_vm._v("\n                          " + _vm._s(value.settlementPrice / 100) + "\n                          "), (item.supplyChannel == 1) ? _c('span', {
        staticClass: "freight-price"
      }, [_vm._v("(+" + _vm._s(value.freight / 100) + ")")]) : _vm._e()]) : _c('span', [_vm._v("\n                          " + _vm._s(value.settlementPrice / 100) + "\n                          "), (item.supplyChannel == 1) ? _c('span', {
        staticClass: "freight-price"
      }, [_vm._v("(+" + _vm._s(value.freight / 100) + ")")]) : _vm._e()])]), _vm._v(" "), _c('td', [(item.isBill == 0) ? _c('span', [_vm._v(_vm._s(value.inventoryNum))]) : _c('span', [_vm._v(_vm._s(value.inventoryNum))])])]) : _vm._e()
    }), 0)])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "category-goods-info"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.goodsName,
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "category-goods-title2"
    }, [_vm._v(_vm._s(item.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-type"
    }, [(item.supplyChannel == 2 || item.supplyChannel == 3) ? _c('div', [_vm._v("\n                社群集采\n              ")]) : _vm._e(), _vm._v(" "), (item.supplyChannel == 1) ? _c('div', [_vm._v("一件代发")]) : _vm._e(), _vm._v(" "), (item.isSelf == 1) ? _c('div', {
      staticStyle: {
        "background-color": "rgb(231, 249, 235)",
        "color": "rgb(88, 191, 106)"
      }
    }, [_vm._v("\n                自产自销\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-price2"
    }, [_c('div', [_vm._v("\n                结算价\n                "), _c('span', [_vm._v("\n                  ¥\n                  "), _c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.originSettlementPrice / 100))])])]), _vm._v(" "), _c('div', [_vm._v("\n                毛利率 ¥\n                " + _vm._s((
      ((item.salePrice - item.settlementPrice) /
        item.salePrice) *
      100
    ).toFixed(2) + "%") + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-price3"
    }, [_c('div', [_vm._v("建议零售价 ¥ " + _vm._s(item.salePrice / 100))]), _vm._v(" "), _c('div', [_vm._v("\n                毛利 ¥\n                "), _c('span', {
      staticStyle: {
        "color": "#ff6015"
      }
    }, [_vm._v(_vm._s((item.salePrice - item.settlementPrice).toFixed(2) / 100))])])])], 1), _vm._v(" "), (_vm.globalIsBill == 0) ? _c('div', [(_vm.noInventoryNum[index].haskc == 0) ? _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("\n              暂无库存\n            ")]) : [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(item.shelves == 0) ? _c('div', {
      staticClass: "category-goods-add-default",
      on: {
        "click": function($event) {
          return _vm.addGoodsAll(index, item.goodsId)
        }
      }
    }, [_vm._v("\n                    加入货架\n                  ")]) : _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("\n                    已加入货架\n                  ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(true || item.exitReport == 0 || item.exitReport == null) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "添加商品报价至报价篮子，可以批量导出商品报价",
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "get-price",
      on: {
        "click": function($event) {
          return _vm.getPrice(index, item.goodsId)
        }
      }
    }, [_vm._v("\n                      获取报价\n                    ")])]) : _vm._e()], 1)], 1)]], 2) : _c('div', [(_vm.noTaxInventoryNum[index].haskc == 0) ? _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("\n              暂无库存\n            ")]) : [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(item.shelves == 0) ? _c('div', {
      staticClass: "category-goods-add-default",
      on: {
        "click": function($event) {
          return _vm.addGoodsAll(index, item.goodsId)
        }
      }
    }, [_vm._v("\n                    加入货架\n                  ")]) : _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("\n                    已加入货架\n                  ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(true || item.exitReport == 0 || item.exitReport == null) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "添加商品报价至报价篮子，可以批量导出商品报价",
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "get-price",
      on: {
        "click": function($event) {
          return _vm.getPrice(index, item.goodsId)
        }
      }
    }, [_vm._v("\n                      获取报价\n                    ")])]) : _vm._e()], 1)], 1)]], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.condition.pageNum,
      "total": _vm.goodsListCount,
      "page-size": 60
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasGoods),
      expression: "!hasGoods"
    }],
    staticClass: "category-goods-wrap-no"
  }, [_c('div', {
    staticClass: "category-goods-wrap-tip"
  }, [_vm._v("没有找到相关商品...")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("\n        我知道了\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a3c69f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Category.vue
// module id = 534
// module chunks = 1